import { z } from "zod";
export const REPORT_NAMES = [
    "quote-conversion",
    "job-status",
    "wip",
    "stock-reorder",
    "open-pos",
    "actual-vs-estimate",
    "invoice-aging",
    "cash-activity",
];
export const reportQuerySchema = z.object({
    from: z.string().date().optional(),
    to: z.string().date().optional(),
    format: z.enum(["json", "csv"]).optional().default("json"),
});
export const importKindSchema = z.enum([
    "customers",
    "suppliers",
    "materials",
    "products",
    "boms",
    "routings",
    "opening-stock",
]);
export const importPayloadSchema = z.object({
    fileName: z.string().trim().min(1, "A file name is required.").max(200),
    csv: z.string().min(1, "CSV content is required.").max(5_000_000),
});
export const importBatchQuerySchema = z.object({
    kind: importKindSchema.optional(),
    limit: z.coerce.number().int().min(1).max(200).default(100),
});
export const importBatchIdParamSchema = z.object({
    batchId: z.string().uuid("Invalid import batch id."),
});
//# sourceMappingURL=operations.js.map